/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { fireClevertapEvent } from 'AccountsUtils'
import { getMappedValue } from '../utils/arabicUtils'
import RowItem from './RowItem'
import DesktopRowItem from './DesktopRowItem'
import SlideModal from './SlideModal'
import BaggageItem from './BaggageItem'

const Baggage = ({ baggage, isPWA, subHeader, tripId }) => {
  const [toggleModal, setToggleModal] = useState(false)
  const [rowheight, setRowheight] = useState('h-12')
  const [modalData, setModalData] = useState(null)
  const { adltBaggage, extraBaggage, infBaggage, defaultText } = baggage
  const toggleViewDetails = (e, data) => {
    fireClevertapEvent('viewed_baggage_details', {
      trip_id: tripId,
      trip_name: subHeader
    })
    e.preventDefault()
    e.stopPropagation()
    setModalData(data)
    setToggleModal(true)
  }

  return (
    <div>
      <If condition={isPWA}>
        <If condition={toggleModal}>
          <SlideModal
            header={getMappedValue('baggage rules')}
            subHeader={subHeader}
            open={toggleModal}
            onCloseClick={() => setToggleModal(false)}
            baggageToggle={true}
          >
            <div className="bg-white p-4 fs-13">
              <p className="fw-500 pb-2">
                {modalData && modalData.type === 'adult' ?
                  getMappedValue('for adult/child') :
                  getMappedValue('for infant')}
              </p>
              <p className="c-grey-70 pt-4 pb-6 lh-copy">
                {modalData && modalData.freeText}
              </p>
            </div>
          </SlideModal>
        </If>
        <If condition={adltBaggage}>
          <BaggageItem
            tripId={tripId}
            defaultText={defaultText}
            toggleViewDetails={toggleViewDetails}
            {...adltBaggage}
            isPWA={isPWA}
            type="adult"
          />
        </If>
        <If
          condition={
            adltBaggage && adltBaggage.hint && adltBaggage.hint.length > 0
          }
        >
          <RowItem
            label={getMappedValue('note')}
            isFlexStart={!isPWA}
            childClass={`${isPWA ? '' : 'fs-caption-2'}`}
            isPWA={isPWA}
            value={adltBaggage.hint}
          />
        </If>
        <If condition={infBaggage}>
          <BaggageItem
            tripId={tripId}
            defaultText={defaultText}
            toggleViewDetails={toggleViewDetails}
            {...infBaggage}
            isPWA={isPWA}
            type="infant"
          />
        </If>
        <Else />
        <DesktopRowItem
          label={getMappedValue('baggage details')}
          isFlexStart={!isPWA}
          childClass="fs-caption-2"
          isPWA={isPWA}
          type="dynamic"
          height={adltBaggage && infBaggage ? 'h-20' : rowheight}
        >
          <div className="flex flex-1 flex-column">
            <If condition={adltBaggage}>
              <div
                className={`flex flex-middle flex-1 bc-neutral-300 pr-2 ${
                  infBaggage ? 'mt-2' : ''
                } ${adltBaggage && adltBaggage.hint ? 'pt-2' : ''}`}
              >
                {/* {<p className="fs-caption-2 tt-capitalize fw-600">adult/child</p>} */}
                <p className="mr-6">{getMappedValue('adult')}</p>
                <BaggageItem
                  tripId={tripId}
                  defaultText={defaultText}
                  {...adltBaggage}
                  isPWA={isPWA}
                  setRowheight={setRowheight}
                  type="adult"
                />
              </div>
            </If>
            <If
              condition={
                adltBaggage && adltBaggage.hint && adltBaggage.hint.length > 0
              }
            >
              <div className="flex flex-1 pb-2">
                {
                  <p className="fs-caption-2 tt-capitalize fw-600">
                    {getMappedValue('note')}
                  </p>
                }
                <p className="pl-2 c-neutral-700">{adltBaggage.hint}</p>
              </div>
            </If>
            <If condition={infBaggage}>
              <div className="flex flex-middle flex-1 mb-2">
                <p className="mr-6">{getMappedValue('infant')}</p>
                <BaggageItem
                  tripId={tripId}
                  defaultText={defaultText}
                  {...infBaggage}
                  setRowheight={setRowheight}
                  isPWA={isPWA}
                  type="infant"
                />
              </div>
            </If>
          </div>
        </DesktopRowItem>
      </If>
      <If condition={extraBaggage && extraBaggage.length > 0}>
        <RowItem
          label={getMappedValue('extra baggage')}
          isFlexStart={!isPWA}
          childClass={`${isPWA ? '' : 'fs-caption-2'}`}
          isPWA={isPWA}
          value={extraBaggage.map(data => data)}
        />
      </If>
    </div>
  )
}

export default Baggage
